export const normalizeQrCode = (value) => String(value ?? "").trim();

export const withOptionalQrCode = (payload, value) => {
    const qrCode = normalizeQrCode(value);
    return qrCode ? { ...payload, qrCode } : payload;
};

export const getApiErrorMessage = (error, fallback) => {
    const data = error?.response?.data;

    if (typeof data === "string" && data.trim()) return data;

    return (
        data?.error ||
        data?.message ||
        data?.title ||
        fallback
    );
};

/** 409 that is not an optimistic-concurrency VersionConflict (e.g. duplicate QR). */
export const isQrCodeConflict = (error) => {
    if (error?.response?.status !== 409) return false;
    return error?.response?.data?.errorCode !== "VersionConflict";
};
